const Grayscale = require('../../src/js/client/components/Grayscale').default;

exports._grayscale = Grayscale;
